import { render, staticRenderFns } from "./Address.vue?vue&type=template&id=090e3ab8&"
import script from "./Address.ts?vue&type=script&lang=js&"
export * from "./Address.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports